/**
 * Canonical API base (must include `/api`). Default: live API.
 * Optional override via REACT_APP_API_URL (with or without trailing `/api`).
 */
function normalizeApiBaseUrl() {
  const raw = process.env.REACT_APP_API_URL || 'https://api.firstcapitalsint.com';
  const trimmed = raw.replace(/\/+$/, '');
  if (trimmed.endsWith('/api')) {
    return trimmed;
  }
  return `${trimmed}/api`;
}

export const API_BASE_URL = normalizeApiBaseUrl();
